import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useAnalyticsData } from "modules/customerTickets/hooks/useAnalyticsData";
import React, { FC } from "react";
import ToolbarItem from "shared/components/DraftEditor/components/ToolbarItem";
import { InfoOutlinedIcon } from "shared/theme/icons/InfoOutlinedIcon";
import { StyledSpinnerWrapper } from "../../styled";
import ComparingSection from "./components/ComparingSection";
import { StyledContainer } from "./styled";

const NumberOfTickets: FC = () => {
  const { thisWeekTotalInquiries, isLoading } = useAnalyticsData();

  return (
    <StyledContainer>
      {!isLoading && (
        <Stack spacing="0.5rem">
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="heading6">
              Number of support tickets
            </Typography>
            <ToolbarItem
              Icon={<InfoOutlinedIcon />}
              isTooltip
              tooltipTitle={
                <Typography variant="body1">
                  <strong>What it does:</strong> Displays the total number of
                  support tickets raised during a specific period.
                  <br />
                  <br />
                  <strong>How it works:</strong> Counts all support tickets
                  raised and calculates the percentage change by comparing the
                  current total to the previous period.
                </Typography>
              }
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="heading1">{thisWeekTotalInquiries}</Typography>
            <ComparingSection />
          </Box>
        </Stack>
      )}
      {isLoading && (
        <StyledSpinnerWrapper>
          <CircularProgress />
        </StyledSpinnerWrapper>
      )}
    </StyledContainer>
  );
};

export default NumberOfTickets;
